export default function InterventionsGrid() {
  const interventions = [
    {
      href: "/reglage-fenetre-oscillo-battant",
      icon: "ri-settings-4-line",
      title: "Réglage oscillo-battant",
      desc: "Fenêtre qui ne bascule plus correctement ? Recalage des ciseaux et des galets à Sélestat.",
    },
    {
      href: "/cremone-fenetre",
      icon: "ri-key-line",
      title: "Réparation crémone",
      desc: "Crémone bloquée ou cassée ? Remplacement du mécanisme de verrouillage chez vous.",
    },
    {
      href: "/poignee-fenetre-bloquee",
      icon: "ri-door-open-line",
      title: "Poignée de fenêtre",
      desc: "Poignée qui tourne dans le vide ou bloquée ? Changement de l'axe et de la poignée.",
    },
    {
      href: "/gond-paumelle-fenetre",
      icon: "ri-hammer-line",
      title: "Gond & paumelle",
      desc: "Fenêtre qui s'affaisse ou frotte ? Remplacement des gonds et réglage de la hauteur.",
    },
    {
      href: "/fenetre-ferme-mal",
      icon: "ri-draft-line",
      title: "Fenêtre qui ferme mal",
      desc: "Fenêtre qui force, ne verrouille plus ou laisse passer l'air ? Réparation et réglage.",
    },
  ];

  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-4 md:mb-6">
            Nos interventions à Sélestat
          </h2>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-8 md:mb-10">
            Quelle que soit la panne sur votre fenêtre à Sélestat, notre technicien arrive avec les outils et les pièces nécessaires pour réparer sur place en une seule visite.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {interventions.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="group bg-white rounded-2xl p-5 md:p-6 border border-rose-100 hover:border-coral/30 transition-colors flex flex-col"
              >
                <div className="w-12 h-12 rounded-xl bg-rose-50 flex items-center justify-center mb-4 group-hover:bg-coral/10 transition-colors">
                  <i className={`${item.icon} text-plum text-xl group-hover:text-coral transition-colors`} />
                </div>
                <h3 className="font-semibold text-base md:text-lg text-plum-dark mb-2 group-hover:text-coral transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base text-plum-dark/70 leading-relaxed flex-1">
                  {item.desc}
                </p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-coral mt-4">
                  En savoir plus
                  <i className="ri-arrow-right-line" />
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}